import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DialogService} from '../../../../services/utils/dialog.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CompaniesService} from '../../../../services/modules/companies.service';
import {SnackBarService} from '../../../../services/utils/snackBar.service';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-card-training-edit',
  templateUrl: './card-training-edit.component.html',
  styleUrls: ['./card-training-edit.component.scss']
})
export class CardTrainingEditComponent implements OnInit {
  s3Bucket: string;
  imgCropperResult: string;

  formPhoto: FormGroup;
  formTrainingType: FormGroup;
  isStateChanged = false;
  isDesignDisabled = false;
  disableFieldsInEditMode = false;

  formData: FormData = new FormData();
  @ViewChild('nameInput', { static: true })
  nameInput!: ElementRef<HTMLInputElement>;

  @ViewChild('descriptionInput', { static: true })
  descriptionInput!: ElementRef<HTMLInputElement>;

  @Input() editData: any;
  @Input() companyInfoId: string;
  @Output() flagEditEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() flagSaveEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private dialogService: DialogService,
    private snackBService: SnackBarService,
    private companiesServices: CompaniesService,
  ) { }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    const isEditMode = this.editData !== undefined && Object.keys(this.editData).length > 0;
    this.formTrainingType = this.fb.group({
      Name: new FormControl('', Validators.required),
      Description: '',
      State: new FormControl({ value: 0, disabled: !isEditMode }, Validators.required),
      Order: [0, Validators.required],
      Id: '',
    });
    this.formPhoto = this.fb.group({
      Photo: new FormControl(''),
    });
    if (this.editData !== undefined) {
      const originalState = this.editData.State ?? 0;
      this.isDesignDisabled = originalState !== 0;
      this.disableFieldsInEditMode = originalState === 1 || originalState === 2;
      this.formTrainingType.patchValue({
        Name: this.editData.Name,
        Description: this.editData.Description,
        State: this.editData.State ?? 0,
        Order: this.editData.Order,
        Id: this.editData.Id,
      });

      this.formTrainingType.get('Order')?.enable();

      if (this.disableFieldsInEditMode) {
        this.formTrainingType.get('Name')?.disable();
        this.formTrainingType.get('Description')?.disable();
        this.formTrainingType.get('Order')?.disable();
      }

      if (this.disableFieldsInEditMode) {
        this.formTrainingType.get('State')?.valueChanges.subscribe(newValue => {
          const hasChanged = newValue !== originalState;
          const isValidChange = (originalState === 1 && newValue === 2) || (originalState === 2 && newValue === 1);

          this.isStateChanged = hasChanged && isValidChange;
        });
      }
    }

    const nameCtrl = this.formTrainingType.get('Name') as FormControl;
    const descriptionCtrl = this.formTrainingType.get('Description') as FormControl;
    nameCtrl.valueChanges.subscribe(raw => {
      const formatted = this.capitalizeFirst(raw);
      if (raw === formatted) { return; }

      const inputEl = this.nameInput.nativeElement;
      const cursorPos = inputEl.selectionStart ?? 0;

      nameCtrl.setValue(formatted, { emitEvent: false });

      setTimeout(() => {
        inputEl.setSelectionRange(cursorPos, cursorPos);
      });
    });

    descriptionCtrl.valueChanges.subscribe(raw => {
      const formatted = this.capitalizeFirst(raw);
      if (raw === formatted) { return; }

      const inputEl = this.descriptionInput.nativeElement;
      const cursorPos = inputEl.selectionStart ?? 0;

      descriptionCtrl.setValue(formatted, { emitEvent: false });

      setTimeout(() => {
        inputEl.setSelectionRange(cursorPos, cursorPos);
      });
    });
  }

  onClickUpdatePhoto(): void {
    if (!this.disableFieldsInEditMode) {
      this.updatePhotoTrainings();
    }
  }


  updatePhotoTrainings() {
    this.dialogService.openDialogGestorImg('CARGAR IMAGEN', [], 'editPhoto', 0, 'true', true).afterClosed().subscribe(formDataPhoto => {
      if (formDataPhoto !== undefined) {
        this.formPhoto = formDataPhoto.FormData;
        this.formData = formDataPhoto.FormData;
        this.imgCropperResult = formDataPhoto.imgResult;
      }
    });
  }

  onSubmitTypeTrainings() {
    const isEdit = this.editData && Object.keys(this.editData).length > 0;
    const stateValue = this.formTrainingType.get('State')?.enabled
      ? Number(this.formTrainingType.get('State')?.value)
      : 0;

    const model: any = {
      AdminInfoId: this.companyInfoId,
      Name: this.capitalizeFirst(this.formTrainingType.get('Name')?.value),
      Description: this.capitalizeFirst(this.formTrainingType.get('Description')?.value),
      State: stateValue,
      Order: Number(this.formTrainingType.get('Order')?.value),
    };

    if (isEdit) {
      Object.assign(model, {
        StateTranslation: this.editData.StateTranslation,
        QuestionOrderType: this.editData.QuestionOrderType,
        ApprovalPercentage: this.editData.ApprovalPercentage,
        RequirementId: this.editData.RequirementId,
        RequirementName: this.editData.RequirementName,
        ValidityType: this.editData.ValidityType,
        ValidityMonths: this.editData.ValidityMonths,
        ValidityEndDate: this.editData.ValidityEndDate,
        IsRenewalRequired: this.editData.IsRenewalRequired,
        ImagePath: this.editData.ImagePath
      });

      const originalState = this.editData.State ?? 0;
      this.companiesServices.putTraining(model, this.editData.Id).subscribe(
        (rest: any) => {
          if (this.imgCropperResult) {
            this.companiesServices.putTrainingUpdateImage(rest.Id, this.formData).subscribe(() => {
              this.snackBService.openSuccess('Foto Actualizada', '', 4000);
              this.flagEditEvent.emit(false);
              this.flagSaveEvent.emit(true);
            });
          } else {
            this.flagEditEvent.emit(false);
            this.flagSaveEvent.emit(true);
          }
        },
        (err) => {
          const errorMsg = typeof err?.error === 'string'
            ? err.error
            : err?.error?.Error ?? err?.error?.message ?? 'Error al guardar los datos';

          this.snackBService.openWarning(errorMsg, '', 5000);
          this.formTrainingType.get('State')?.setValue(originalState, { emitEvent: false });
        }
      );

    } else {
      this.companiesServices.postTraining(model).subscribe((rest: any) => {
        this.companiesServices.putTrainingUpdateImage(rest.Id, this.formData).subscribe(() => {
          this.snackBService.openSuccess('Foto Actualizada', '', 4000);
          this.flagEditEvent.emit(false);
          this.flagSaveEvent.emit(true);
        });
      });
    }
  }

  private capitalizeFirst(value: string): string {
    if (!value) { return ''; }
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  getImg(): string {
    if (this.imgCropperResult !== undefined && this.imgCropperResult !== null) {
      return this.imgCropperResult;
    }
    if (this.editData !== undefined && this.editData.ImagePath !== null) {
      return `${this.s3Bucket}${this.editData.ImagePath}`;
    }
    return `${this.s3Bucket}assets/images/personblue.png`;
  }


  cancelTrainings() {
    this.flagEditEvent.emit(false);
  }

}
